import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createBlock as _createBlock, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = {
  key: 0,
  "aria-hidden": "true"
}
const _hoisted_3 = {
  key: 1,
  class: "apenas-leitor-tela"
}
const _hoisted_4 = ["id"]
const _hoisted_5 = ["id", "value", "disabled", "required", "aria-label", "aria-required", "aria-invalid", "aria-describedby"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dropdown-consulte", _ctx.$attrs.class]),
    style: _normalizeStyle(_ctx.$attrs.style)
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.idCampo,
          class: _normalizeClass(_ctx.rotuloVisivel ? 'form-label' : 'apenas-leitor-tela')
        }, [
          _createTextVNode(_toDisplayString(_ctx.label), 1),
          (_ctx.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, " *"))
            : _createCommentVNode("", true),
          (_ctx.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, " (obrigatório)"))
            : _createCommentVNode("", true)
        ], 10, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.usarBusca)
      ? (_openBlock(), _createBlock(_component_MultiSelect, {
          key: 1,
          id: _ctx.idCampo,
          mode: "single",
          searchable: true,
          "append-to-body": true,
          options: _ctx.opcoesDaBusca,
          "model-value": _ctx.valorDaBusca,
          disabled: _ctx.disabled,
          "can-clear": !!_ctx.placeholder && _ctx.valorDaBusca !== _ctx.opcaoVazia,
          "can-deselect": false,
          placeholder: _ctx.placeholder || undefined,
          aria: _ctx.ariaDaBusca,
          class: _normalizeClass(_ctx.classeCampo),
          style: _normalizeStyle(_ctx.estiloCampo),
          "no-options-text": "Nenhuma opção disponível",
          "no-results-text": "Nenhuma opção encontrada",
          onChange: _ctx.aoEscolherNaBusca,
          onKeydown: _ctx.aoTeclarNaBusca
        }, null, 8, ["id", "options", "model-value", "disabled", "can-clear", "placeholder", "aria", "class", "style", "onChange", "onKeydown"]))
      : _createCommentVNode("", true),
    (_ctx.usarBusca && _ctx.nomeAcessivel)
      ? (_openBlock(), _createElementBlock("span", {
          key: 2,
          id: _ctx.idNomeAcessivel,
          class: "apenas-leitor-tela"
        }, _toDisplayString(_ctx.nomeAcessivel), 9, _hoisted_4))
      : _createCommentVNode("", true),
    (!_ctx.usarBusca)
      ? (_openBlock(), _createElementBlock("select", _mergeProps({ key: 3 }, _ctx.atributosDoCampo, {
          id: _ctx.idCampo,
          class: ["form-select", _ctx.classeCampo],
          style: _ctx.estiloCampo,
          value: _ctx.valorAtual,
          disabled: _ctx.disabled,
          required: _ctx.required,
          "aria-label": _ctx.label ? undefined : _ctx.ariaLabel || undefined,
          "aria-required": _ctx.required ? 'true' : undefined,
          "aria-invalid": _ctx.mensagemErro ? 'true' : undefined,
          "aria-describedby": _ctx.mensagemErro ? _ctx.idErro : undefined,
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.aoTrocar && _ctx.aoTrocar(...args)))
        }), [
          (_ctx.placeholder)
            ? (_openBlock(), _createElementBlock("option", {
                key: 0,
                value: _ctx.valorVazio
              }, _toDisplayString(_ctx.placeholder), 9, _hoisted_6))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default", {}, () => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.array, (item) => {
              return (_openBlock(), _createElementBlock("option", {
                key: String(item[_ctx.rowValue]),
                value: item[_ctx.rowValue]
              }, _toDisplayString(item[_ctx.rowLabel]), 9, _hoisted_7))
            }), 128))
          ], true)
        ], 16, _hoisted_5))
      : _createCommentVNode("", true),
    (_ctx.mensagemErro)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          id: _ctx.idErro,
          class: "invalid-feedback d-block"
        }, _toDisplayString(_ctx.mensagemErro), 9, _hoisted_8))
      : _createCommentVNode("", true)
  ], 6))
}